(function () {
  'use strict';
  function setup(gallery) {
    if (gallery.dataset.enhanced) return;
    const list = gallery.querySelector('.hk-sleeve-gallery__list');
    const cards = Array.from(list.children);
    if (!cards.length) return;
    const toggle = gallery.querySelector('[data-gallery-toggle]');
    const nav = gallery.querySelector('[data-gallery-navigation]');
    const prev = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    const position = gallery.querySelector('[data-gallery-position]');
    const feedback = gallery.querySelector('[data-gallery-feedback]');
    gallery.dataset.enhanced = 'true';
    gallery.dataset.expanded = 'false';
    toggle.hidden = nav.hidden = false;
    toggle.textContent = 'View all ' + cards.length + ' designs';
    const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function stride() { return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : cards[0].offsetWidth; }
    function update() {
      if (!gallery.isConnected || gallery.dataset.expanded === 'true') return;
      const gap = stride();
      const first = Math.max(1, Math.floor((list.scrollLeft + 2) / gap) + 1);
      const last = Math.min(cards.length, Math.ceil((list.scrollLeft + list.clientWidth - 8) / gap));
      position.textContent = first === last ? 'Design ' + first + ' of ' + cards.length : 'Designs ' + first + ' to ' + last + ' of ' + cards.length;
      prev.disabled = list.scrollLeft < 2;
      next.disabled = list.scrollLeft >= list.scrollWidth - list.clientWidth - 2;
    }
    let frame;
    list.addEventListener('scroll', () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); }, { passive:true });
    if (typeof ResizeObserver === 'function') new ResizeObserver(update).observe(list);
    else window.addEventListener('resize', update);
    function advance(direction) {
      const step = stride();
      const count = Math.max(1, Math.floor((list.clientWidth + 18) / step));
      list.scrollBy({left:direction * count * step, behavior:reducedMotion() ? 'instant' : 'smooth'});
    }
    prev.addEventListener('click', () => advance(-1));
    next.addEventListener('click', () => advance(1));
    toggle.addEventListener('click', () => {
      const expanded = gallery.dataset.expanded !== 'true';
      gallery.dataset.expanded = String(expanded);
      toggle.setAttribute('aria-expanded', String(expanded));
      toggle.textContent = expanded ? 'Show design slider' : 'View all ' + cards.length + ' designs';
      nav.hidden = expanded;
      if (!expanded) { list.scrollLeft = 0; update(); }
    });
    // Use the engine's existing native chooser so mode changes, colors and panel
    // refresh keep one implementation. No direct writes to debug engine globals.
    function choose(button) {
      feedback.textContent = '';
      if (typeof window.HK_OPEN !== 'function') {
        feedback.textContent = 'The designer is still loading. Please try Customize this design again in a moment.';
        return;
      }
      const before = new Set(document.querySelectorAll('.hk-overlay'));
      window.HK_OPEN(button);
      const overlay = Array.from(document.querySelectorAll('.hk-overlay')).find(n => !before.has(n));
      if (!overlay) { feedback.textContent = 'The designer could not open. Please try again.'; return; }
      let done = false;
      const observer = new MutationObserver(apply);
      const timer = setTimeout(() => {
        if (!overlay.isConnected || done) return stop();
        const message = document.createElement('p');
        message.setAttribute('role', 'status');
        message.textContent = 'We could not select ' + button.dataset.designName + '. Please choose your design in Logo & design.';
        (overlay.querySelector('#panel') || overlay).prepend(message);
        stop();
      }, 90000);
      function stop() { done = true; clearTimeout(timer); observer.disconnect(); }
      function apply() {
        if (!overlay.isConnected) return stop();
        const select = Array.from(overlay.querySelectorAll('.ir-design-select select')).find(s => Array.from(s.options).some(o => o.value === button.dataset.designId));
        if (!select) return;
        stop();
        select.value = button.dataset.designId;
        select.dispatchEvent(new Event('change', {bubbles:true}));
        const heading = select.closest('.acc')?.querySelector('.acc-head');
        if (heading && heading.getAttribute('aria-expanded') !== 'true') heading.click();
      }
      observer.observe(document.body, {subtree:true,childList:true});
      apply();
    }
    gallery.addEventListener('click', event => {
      const button = event.target.closest('[data-design-id]');
      if (button && gallery.contains(button)) choose(button);
    });
    update();
  }
  document.querySelectorAll('[data-hk-sleeve-gallery]').forEach(setup);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-hk-sleeve-gallery]').forEach(setup));
}());
